module.exports = __webpack_public_path__ + "img/wolfgang_lassak.d673ff68.jpg";